<div
  class="delete-success-stack"
  role="status"
  aria-live="polite"
  [class.is-closing]="isClosing()"
>
  <div class="delete-success-stack__success">
    <div class="delete-success-stack__success-icon">
      <i class="pi pi-check-circle"></i>
    </div>

    <div class="delete-success-stack__body">
      <p class="delete-success-stack__title">
        {{ 'reportLoad.delete.successTitle' | translate }}
      </p>

      <p class="delete-success-stack__message">
        {{ 'reportLoad.delete.successMessagePrefix' | translate }}
        <strong>{{ loadId() }}</strong>
        {{ 'reportLoad.delete.successMessageSuffix' | translate }}
      </p>
    </div>

    <button
      type="button"
      class="delete-success-stack__close"
      (click)="close()"
      [attr.aria-label]="'reportLoad.delete.successCloseAriaLabel' | translate"
      [title]="'button.closeBtnTitle' | translate"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="delete-success-stack__reminder">
    <div class="delete-success-stack__reminder-icon">
      <i class="pi pi-exclamation-circle"></i>
    </div>

    <div class="delete-success-stack__body">
      <p class="delete-success-stack__reminder-title">
        {{ 'reportLoad.delete.reminderTitle' | translate }}
      </p>

      <p class="delete-success-stack__reminder-message">
        {{ 'reportLoad.delete.reminderMessagePrefix' | translate }}
        @if (policyNumber()) {
          <strong>{{ policyNumber() }}</strong>
        }
        {{ 'reportLoad.delete.reminderMessageSuffix' | translate }}
      </p>
    </div>
  </div>
</div>